import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { GridFooterContainer } from "@mui/x-data-grid";
interface CustomFooterProps {
    currentPage: number;
    onPageChange: Function;
    totalPages: number;
    pageSize: number;
    onPageSizeChange: Function;
}

export function CustomFooter({
    currentPage,
    totalPages,
    pageSize,
    onPageChange,
    onPageSizeChange,
}: CustomFooterProps) {
    return (
        <GridFooterContainer>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px",
                    width: "100%",
                }}
            >
                <span>
                    Page {currentPage + 1} sur {totalPages}
                </span>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ marginRight: "8px" }}>
                            Lignes par page
                        </span>
                        <select
                            aria-label="Lignes par page"
                            onChange={(e) =>
                                onPageSizeChange(parseInt(e.target.value, 10))
                            }
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={40}>40</option>
                            <option value={50}>50</option>
                            <option value={250}>250</option>
                        </select>
                    </div>

                    <ArrowBackIosNewIcon
                        aria-label="previous page"
                        style={{
                            width: "15px",
                            cursor:
                                currentPage === 0 ? "not-allowed" : "pointer",
                            opacity: currentPage === 0 ? 0.5 : 1,
                        }}
                        onClick={() => {
                            if (currentPage > 0) onPageChange(currentPage - 1);
                        }}
                    />
                    <ArrowForwardIosIcon
                        aria-label="next page"
                        style={{
                            width: "15px",
                            cursor:
                                currentPage >= totalPages - 1
                                    ? "not-allowed"
                                    : "pointer",
                            opacity: currentPage >= totalPages - 1 ? 0.5 : 1,
                        }}
                        onClick={() => {
                            if (currentPage < totalPages - 1)
                                onPageChange(currentPage + 1);
                        }}
                    />
                </div>
            </div>
        </GridFooterContainer>
    );
}
